import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";

export default function PublicAppDirectoryPage() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/marketplace/apps")
      .then((response) => setApps(response.data.items || []))
      .catch(() => setApps([]))
      .finally(() => setLoading(false));
  }, []);

  return <main className="min-h-screen bg-[#0a0a0f] px-6 py-10 text-white">
    <div className="mx-auto max-w-6xl">
      <div className="flex flex-wrap items-center justify-between gap-4 border-b border-white/10 pb-7">
        <Link to="/" className="flex items-center gap-2 font-semibold"><span className="h-8 w-8 rounded-lg bg-gradient-to-br from-violet-500 to-fuchsia-500" /> OmniMark HQ</Link>
        <div className="flex gap-3"><Link to="/login"><Button variant="ghost" className="text-white hover:bg-white/10 hover:text-white">Sign in</Button></Link><Link to="/login"><Button className="bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white">Start building</Button></Link></div>
      </div>

      <section className="py-16 text-center">
        <div className="mx-auto inline-flex rounded-full border border-violet-400/30 bg-violet-400/10 px-4 py-2 text-sm text-violet-200">OmniMark App Directory</div>
        <h1 className="mx-auto mt-6 max-w-3xl text-4xl font-bold tracking-tight sm:text-6xl">Discover apps built to move work forward.</h1>
        <p className="mx-auto mt-5 max-w-2xl text-lg text-white/60">Every directory listing has a public HTTPS destination. OmniMark scans customer submissions for policy concerns; only flagged listings wait for review.</p>
      </section>

      {loading ? <div className="py-12 text-center text-white/50">Loading the directory…</div> : <section className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {apps.map((app) => <article key={app.id} className="flex min-h-64 flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-6 shadow-xl shadow-black/10">
          <div className="flex items-start justify-between gap-3"><div className="rounded-full bg-white/10 px-3 py-1 text-xs text-white/65">{app.category}</div>{app.official && <div className="rounded-full bg-emerald-400/15 px-3 py-1 text-xs text-emerald-200">Official</div>}</div>
          <h2 className="mt-6 text-2xl font-semibold">{app.name}</h2>
          <p className="mt-2 font-medium text-violet-200">{app.tagline}</p>
          <p className="mt-4 flex-1 text-sm leading-relaxed text-white/60">{app.description}</p>
          <a className="mt-6" href={app.app_url} target="_blank" rel="noreferrer"><Button className="w-full bg-white text-slate-950 hover:bg-white/90">Open app</Button></a>
        </article>)}
      </section>}

      <section className="mt-16 rounded-3xl border border-violet-400/20 bg-gradient-to-r from-violet-600/20 to-fuchsia-600/20 p-8 text-center">
        <h2 className="text-2xl font-semibold">Have an app to share?</h2>
        <p className="mx-auto mt-3 max-w-xl text-white/65">Build in OmniCode, attach a real public HTTPS URL, and let the automated policy scan decide whether the listing can publish immediately.</p>
        <Link to="/login" className="mt-6 inline-block"><Button className="bg-white text-slate-950 hover:bg-white/90">Build with OmniCode</Button></Link>
      </section>
    </div>
  </main>;
}
